import { render, staticRenderFns } from "./effectSelected.vue?vue&type=template&id=a2c1f406&scoped=true"
import script from "./effectSelected.vue?vue&type=script&lang=js"
export * from "./effectSelected.vue?vue&type=script&lang=js"
import style0 from "./effectSelected.vue?vue&type=style&index=0&id=a2c1f406&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c1f406",
  null
  
)

export default component.exports